import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { BrandColorsModalComponent } from 'src/app/components/brand-colors-modal/brand-colors-modal.component';
import { BrandNameModalComponent } from 'src/app/components/brand-name-modal/brand-name-modal.component';
import { DomainsModalComponent } from 'src/app/components/domains-modal/domains-modal.component';
import { OrgDetailsModalComponent } from 'src/app/components/org-details-modal/org-details-modal.component';
import { OrgLogoModalComponent } from 'src/app/components/org-logo-modal/org-logo-modal.component';
import { OrgNameModalComponent } from 'src/app/components/org-name-modal/org-name-modal.component';
import { QuestionnaireLimitModalComponent } from 'src/app/components/questionnaire-limit-modal/questionnaire-limit-modal.component';
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import * as _ from 'lodash';
import { OrgDepartmentsModalComponent } from 'src/app/components/org-departments-modal/org-departments-modal.component';
import { OrgDeleteDepartmentModalComponent } from 'src/app/components/org-delete-department-modal/org-delete-department-modal.component';
import { WarningModalService } from 'src/app/services/warning-modal/warning-modal.service';

@Component({
  selector: 'app-organisation-and-brand',
  templateUrl: './organisation-and-brand.component.pug',
  styleUrls: ['./organisation-and-brand.component.scss'],
  standalone: false
})
export class OrganisationAndBrandComponent implements OnInit {

  org_detail: any;
  org_loaded = false;
  departmentLoaded = true;
  industry = '';
  domains = '';
  email_sms_langs = '';
  participant_langs = '';
  initialDepartmentsList: any = [];
  deletedDepartmentsList: any = [];
  deletedDomainList: any = [];
  addedDomainList: any = [];
  domainsList = [];
  managePermissions = {}
  departmentList: any;
  totalDepartments: any = 0;
  enabledDepartments: any = 0;
  canViewOrgAndBrand = false;
  previews: any = {
    domains: '',
    departments:''
  }
  errorMap = new Map([
    ["brand_name", new Map([["duplicate", $localize`An organisation with this name already exists, please contact support@xref.com.`]])],
    ["logo", new Map([["INFECTED_FILE_ERROR", $localize`Virus detected. Please upload a virus-free file and try again.`]])],
    ["domains", new Map([["social", $localize`Only business email domains can be added`]])],
  ]);
  @Input() org: any;

  constructor(
    public bsModalRef: BsModalRef,
    private organisationService: OrganisationService,
    private alertList: AlertBannerService,
    private modalService: BsModalService,
    public permissions: PermissionsService,
    private warningModal: WarningModalService) { }

  ngOnInit(): void {
    if (this.org !== undefined) {
      this.loadOrg();
      if (this.permissions.hasUserOrgPermission('can_view_organisation_and_brand')) {
        this.managePermissions['can_view_organisation_and_brand'] = true;
      }
      this.canViewOrgAndBrand = this.permissions.hasPermission("can_view_organisation_and_brand")
      if(this.canViewOrgAndBrand){
        this.getLatestDomains();
      }
      this.getLatestDomains();

      const success = () => {
        if (this.permissions.hasUserOrgPermission('can_manage_email_domains')) {
          this.managePermissions['can_manage_email_domains'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_organisation_logo')) {
          this.managePermissions['manage_organisation_logo'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_organisation_name')) {
          this.managePermissions['manage_organisation_name'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_brand_name')) {
          this.managePermissions['manage_brand_name'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_brand_colours')) {
          this.managePermissions['manage_brand_colours'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_organisation_details')) {
          this.managePermissions['manage_organisation_details'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_email_sms_template')) {
          this.managePermissions['manage_email_sms_template'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_question_limit')) {
          this.managePermissions['manage_question_limit'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_participant_language')) {
          this.managePermissions['manage_participant_language'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_email_sms_language')) {
          this.managePermissions['manage_email_sms_language'] = true;
        }
        if (this.permissions.hasUserOrgPermission('manage_domains')) {
          this.managePermissions['manage_domains'] = true;
        }

      }
      const error = () => {
        console.log(error);
        this.org_loaded = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }

      this.permissions.accManagementPermissionSubject.subscribe((hasDataLoaded) => {
        if (hasDataLoaded) {
          success();
        } else {
          error();
        }
      });
    }
    this.getUpdatedDepartment();
  }

  getUpdatedDepartment(): void{
    this.organisationService.getNewDepartments().subscribe((data) => {
      if(data?.departments) this.departmentList = data.departments;
      if (data?.total_departments) this.totalDepartments = data.total_departments
    })
  }

  loadOrg() {
    const offset = 0;
    const limit = 19;
    const sort = 'department'

    this.organisationService
        .getOrganisation()
        .subscribe(data => {
          this.org_detail = data
          this.organisationService.setOrganisationDetails(this.org_detail);
          this.domainsList = this.org_detail['domains']
          let domainObj = this.domainsList.map((item) => {
            return {
              name: item
            }
          })
          this.previews['domains'] = this.generatePreviewString(domainObj, 'name', 20)
          this.formatOrgForVisualisation();
          }, error => {
            console.log(error);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          });
    this.organisationService
    .getPaginatedDepartments(offset, limit, sort)
    .subscribe(
      (data: any) => {
        this.departmentList = data.data.departments;
        this.enabledDepartments = data.data.enabled;
        this.totalDepartments = data.data.total;
        this.org_loaded = true;
        this.previews['departments'] = this.generatePreviewString(this.departmentList, 'department',20)
      },
      (error: any) => {
        this.departmentList = [];
        this.enabledDepartments = 0;
        this.totalDepartments = 0;
        this.org_loaded = true;
      }
    );
  }

  showOrgDetailsModal() {
    let initialState = {};
    initialState = {'org_size': this.org_detail['org_size'], 'industry': this.org_detail['industry']};
    this.bsModalRef = this.modalService.show(OrgDetailsModalComponent, {
      class: 'modal-dialog-centered max-width-400', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }

  showOrgLogoModal() {
    let initialState = { 'logo': this.org_detail['logo'] };
    this.bsModalRef = this.modalService.show(OrgLogoModalComponent, {
      class: 'modal-dialog-centered max-width-400', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }

  showOrgNameModal() {
    let initialState = { 'billing_name': this.org_detail['billing_name'] };
    this.bsModalRef = this.modalService.show(OrgNameModalComponent, {
      class: 'modal-dialog-centered max-width-552 max-height-257', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }

  warningPopup() {
    let title = $localize`Remove email domain? `;
    let message = $localize`Are you sure you want to remove this email domain?`;
    let cancelButton = $localize`Cancel`;
    let agreeButton = $localize`Remove`;
    return this.warningModal.confirm(title = title, message = message, false, cancelButton, agreeButton, true);
  }

  showDomainsModal(domainsToDelete?: any, domainsToAdd?: any) {
    let initialState = {'domains': _.cloneDeep(this.org_detail['domains']), 'deleteDomains': domainsToDelete, 'addDomains': domainsToAdd};
    this.bsModalRef = this.modalService.show(DomainsModalComponent, {
      class: 'modal-dialog-centered max-width-552 max-height-411', initialState
    });

    this.bsModalRef.content.deleteDomainClick.subscribe(domainHandler => {
      this.warningPopup().subscribe(confirmDelete => {
        let existingDomains = new Set(this.org_detail['domains']);
        let addedDomains = new Set(domainHandler.addedDomainList);
        let removedDomains = new Set(domainHandler.removeDomainList);
        addedDomains.forEach(domain => {
            existingDomains.add(domain);
        });
        removedDomains.forEach(domain => {
            existingDomains.delete(domain);
        });
        if (confirmDelete) {
          this.org_detail['domains'] = Array.from(existingDomains);
          this.showDomainsModal(removedDomains, addedDomains);
        } else {
          existingDomains.add(domainHandler.domainToDelete);
          removedDomains.delete(domainHandler.domainToDelete);
          this.org_detail['domains'] = Array.from(existingDomains);
          this.showDomainsModal(removedDomains, addedDomains);
        }
      })
    })
    this.bsModalRef.content.event.subscribe(updates => {
      this.org_loaded = false;
      if (updates.add.length > 0) {
        this.updateEmailDomains(updates.add);
      }
      if(updates.remove.length > 0) {
        this.removeEmailDomains(updates.remove);
      }
    });
  }

  showBrandNameModal() {
    let initialState = { 'brand_name': this.org_detail['brand_name'] };
    this.bsModalRef = this.modalService.show(BrandNameModalComponent, {
      class: 'modal-dialog-centered max-width-552 max-height-257', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }

  showBrandColorsModal() {
    let initialState = { 'color': this.org_detail['color'], 'secondary_color': this.org_detail['secondary_color'] };
    this.bsModalRef = this.modalService.show(BrandColorsModalComponent, {
      class: 'modal-lg max-width-898 max-height-642', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }

  showQuestionnaireLimitModal() {
    let initialState = { 'questionnaire_limit': this.org_detail['questionnaire_limit'] };
    this.bsModalRef = this.modalService.show(QuestionnaireLimitModalComponent, {
      class: 'modal-dialog-centered max-width-400', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }

  showOrgDepartmentsModal(openingFromMenu=false) {
    if (openingFromMenu) {
      // User has initiated opening the modal, keep copy to revert to if they cancel
      const offset = 0;
      const limit = 19;
      const sort = 'department'
      this.initialDepartmentsList = _.cloneDeep(this.departmentList);
      this.getDepartments(offset, limit, sort)
    }
    else{
        this.initialDepartmentsList = _.cloneDeep(this.departmentList);
        this.showDepartmentModal()
    }
  }

  getDepartments(offset, limit, sort): void{
    this.departmentLoaded = false
    this.organisationService
    .getPaginatedDepartments(offset, limit, sort)
    .subscribe(
      (data: any) => {
        this.departmentList = data.data.departments;
        this.enabledDepartments = data.data.enabled;
        this.totalDepartments = data.data.total;
        this.departmentLoaded = true;
        this.showDepartmentModal()
      },
      (error: any) => {
        this.departmentList = [];
        this.enabledDepartments = 0;
        this.totalDepartments = 0;
        this.departmentLoaded = true;
      }
    );
  }

  showDepartmentModal(){
    // Create delete handler function to pass to modal
    const deleteHandler = (department: any) => {
      if (department.times_used > 0) {
        this.deleteDepartment(department)
      } else {
        this.confirmDeleteDepartment(department)
      };
    };

    let initialState = {
      'departmentList': this.departmentList ?  [...this.departmentList] : [],
      'deletedDepartmentsList': this.deletedDepartmentsList,
      'enabledDepartments': this.enabledDepartments,
      'totalDepartments': this.totalDepartments,
      'deleteHandler': deleteHandler
    };
    this.bsModalRef = this.modalService.show(OrgDepartmentsModalComponent, {
      class: 'modal-dialog-centered modal-lg', initialState
    });

    // Note: deleteHandler is handled by the modal component via ngOnInit when passed in initialState
    // No need for direct subscription here to avoid duplicate invocations

    // Revert all department changes when the user presses 'Cancel'
    this.bsModalRef.content.closeModalEvent.subscribe(res => {
      this.departmentList = this.initialDepartmentsList;
    })

    // Revert all department changes when the user clicks on the backdrop or presses ESC
    this.bsModalRef.onHide?.subscribe(reason => {
      if(reason === 'backdrop-click' || reason === 'esc') {
        this.departmentList = this.initialDepartmentsList;
      }
    })
  }

  deleteDepartment(departmentToDelete) {
        let initialState = { 'departmentToDelete': departmentToDelete, 'departmentList': this.departmentList };

    const deleteDepartmentModal = this.modalService.show(
      OrgDeleteDepartmentModalComponent,
      { class: 'modal-dialog-scrollable add-question-modal', initialState, ignoreBackdropClick: true}
    )

    deleteDepartmentModal.content?.closeModalEvent.subscribe(res=> {
      if(res.showConfirmation) {
        this.confirmDeleteDepartment(departmentToDelete, res.newDepartment, this.departmentList )
      } else {
        this.showOrgDepartmentsModal()
      }
    });
  }

  confirmDeleteDepartment(oldDepartment, newDepartment: any=null, departmentList: any=null) {
    const title = $localize`Delete department`;
    const cancelButton = $localize`Cancel`;
    let message = '';
    let deleteButton = '';

    if(oldDepartment.times_used  === 0) {
      message = $localize`Are you sure you want to delete the department "${oldDepartment.department}"?`;
      deleteButton = $localize`Delete`;
    } else if (oldDepartment.times_used === 1) {
      message = $localize`Are you sure you want to delete the department "${oldDepartment.department}" and reassign ${oldDepartment.times_used} person?`
      deleteButton = $localize`Reassign and delete`;
    } else {
      message = $localize`Are you sure you want to delete the department "${oldDepartment.department}" and reassign ${oldDepartment.times_used} people?`
      deleteButton = $localize`Reassign and delete`;
    }

    this.warningModal.confirm(title, message, false, cancelButton, deleteButton, true).subscribe(confirmDelete => {
      if (confirmDelete) {
        // Mark department for deletion
        oldDepartment.is_deleted = true;
        if (newDepartment && newDepartment.id) {
          departmentList.find(each => each.id == newDepartment.id).times_used += oldDepartment.times_used;
          this.deletedDepartmentsList.push({ oldDepartment: oldDepartment.id, newDepartment: newDepartment.id })

        } else {
          if (oldDepartment?.id) this.departmentList=this.departmentList.filter(each => each.id !== oldDepartment.id)
          this.deletedDepartmentsList.push({ oldDepartment: oldDepartment.id, newDepartment: -1})
        }
        this.showOrgDepartmentsModal();
      } else {
        if (oldDepartment.times_used > 0) {
          // Cancelling, go back the delete department modal
          this.deleteDepartment(oldDepartment)
          this.showOrgDepartmentsModal()
        } else {
          // Go back to the department list view
          this.showOrgDepartmentsModal()
        }
      }
    });
  }

  private formatOrgForVisualisation() {
    this.industry = this.org_detail['industry'] !== "" ? this.org_detail['industry'] : "Update";
  }

  private getLatestDomains() {
    this.organisationService.getEmailDomains().subscribe((res) => {
      if (res.data) {
        this.org_detail['domains'] = res.data.domains;
        this.domainsList = res.data.domains;
        let domainObj = this.org_detail['domains'].map((item) => {
          return {
            name: item
          }
        })
        this.previews['domains'] = this.generatePreviewString(domainObj, 'name', 20)
        this.org_loaded = true;
      }
    })
  }

  private updateEmailDomains(toAddDomains) {
      this.organisationService.addEmailDomains(toAddDomains).subscribe(data => {
      if (data['saved']) {
        this.bsModalRef.hide();
        if (this.alertList.length() === 0) {
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Changes have been saved.`,
            keepOnRouteChange: true
        }]);
        }
        this.getLatestDomains();
      }
    },error => {
        let messages: Array<any> = [];
        if (error.error['data'] !== null) {
          for (const [key, value] of Object.entries(error.error['data']['errors'])) {
            let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
            let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
            messages.push({
              'type': 'danger',
              'message': message
            });
          }
        } else {
          messages.push({
            'type': 'danger',
            'message': $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          });
        }
        this.bsModalRef.content.setMessages(messages);
      });

  }

  private removeEmailDomains(toDeleteDomains) {
      this.organisationService.deleteEmailDomains(toDeleteDomains).subscribe(data => {
        if (data['deleted']) {
          this.bsModalRef.hide();
          if (this.alertList.length() === 0) {
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! Changes have been saved.`,
              keepOnRouteChange: true
          }]);
        }
          this.getLatestDomains()

      }
    },error => {
        let messages: Array<any> = [];
        if (error.error['data'] !== null) {
          for (const [key, value] of Object.entries(error.error['data']['errors'])) {
            let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
            let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
            messages.push({
              'type': 'danger',
              'message': message
            });
          }
        } else {
          messages.push({
            'type': 'danger',
            'message': $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          });
        }
        this.bsModalRef.content.setMessages(messages);
      });
  }

  private updateOrganisation(updates) {
    this.organisationService.updateOrganisation(updates).subscribe(data => {
      if (data['saved']) {
        this.bsModalRef.content.markAsPristine();
        this.bsModalRef.hide();
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Changes have been saved.`,
          keepOnRouteChange: true
        }]);
        for (const [key, value] of Object.entries(updates)) {
          this.org_detail[key] = value;
          if (key === "brand_name") {
            this.org["brand_name"] = value;
          }
        }

        if (updates instanceof FormData) {
          this.org['logo'] = this.bsModalRef.content.avatar;
          this.org_detail['logo'] = this.org['logo'];
        }
        this.formatOrgForVisualisation();
      }
      }, error => {
        let messages: Array<any> = [];
        if (error.error['data'] !== null) {
          for (const [key, value] of Object.entries(error.error['data']['errors'])) {
            let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
            let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
            messages.push({
              'type': 'danger',
              'message': message
            });
          }
        } else {
          messages.push({
            'type': 'danger',
            'message': $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          });
        }
        this.bsModalRef.content.setMessages(messages);
      });
  }

  generatePreviewString(list: any[], key: string, maxLen: number) {
    const values = list.map(object => object[key])
    let  string = '';
    let index=0
    while (index < values.length) {
      index != 0 ? string += `, ${values[index]}` : string += `${values[index]}`
      if (string.length >= maxLen) {
        break
      }
      else {
        index++;
      }
    }
    string = string.trim()
    let words = string.split(",").map(item => item.trim())
    let remaining = values.filter(element => !words.includes(element))
    if (remaining.length !>0) {
      return `${string} & ${remaining.length} more`
    }
    else {
      return `${string}`
    }
  }
}
